module.exports = __webpack_public_path__ + "static/media/item_1_5_comp.27328943.png";